// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
// import defaultReducer from "./slices/DefaultSlice";
// import referralsReducer from "./slices/ReferralsSlice";
import vendorReducer from "./slices/VendorSlice";
// import referralpaymentsReducer from "./slices/ReferralpaymentsSlice";
// import vendorinvoicesReducer from "./slices/VendorinvoicesSlice";
// import disputesReducer from "./slices/DisputesSlice";
import waitlistReducer from "./slices/WaitlistSlice";
import faqsReducer from "./slices/FaqsSlice";
// import bannersReducer from "./slices/BannersSlice";
// import industrysectorcategoriesReducer from "./slices/IndustrysectorcategoriesSlice";
// import featuredvendorsReducer from "./slices/FeaturedvendorsSlice";
import vendorrecommendationsReducer from "./slices/VendorrecommendationsSlice";
// import adminaccountsReducer from "./slices/AdminaccountsSlice";
// import membersReducer from "./slices/MembersSlice";
import vendorsonhomeReducer from "./slices/VendorsonhomeSlice";
import queriesReducer from "./slices/QueriesSlice";
import authReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    // default: defaultReducer,
    // referrals: referralsReducer,
    vendor: vendorReducer,
    // referralpayments: referralpaymentsReducer,
    // vendorinvoices: vendorinvoicesReducer,
    // disputes: disputesReducer,
    waitlist: waitlistReducer,
    faqs: faqsReducer,
    // banners: bannersReducer,
    // industrysectorcategories: industrysectorcategoriesReducer,
    // featuredvendors: featuredvendorsReducer,
    vendorrecommendations: vendorrecommendationsReducer,
    // adminaccounts: adminaccountsReducer,
    // members: membersReducer,
    vendorsonhome: vendorsonhomeReducer,
    queries: queriesReducer,
    auth: authReducer,
  },
  middleware: (getDefault) => getDefault({ serializableCheck: false }),
});

export default store;
